import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { PhoneCall } from 'lucide-react'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const activeCallDefinition: SmartSignalDefinition<{ active_call?: boolean }> = {
  key: 'active-call',
  label: 'Active call',
  extract: (e) => ({ active_call: e.active_call }),
  icon(e) {
    const p = this.extract(e)?.active_call
    return (
      <PhoneCall
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.active_call
    return p === true
  },
  isWeb: () => false,
  isMobile: () => true,
  searchFor: '"active_call":',
  documentationHash: '#active-call-detection',
  urlParamKey: IdentificationUrlKeys.ActiveCall,
}
